import axios from "axios";
import { fetchUserManagementList } from "../../app/redux/slices/userManagement/userManagementSlice";
import { authAxios } from "../config";
import { ApiKey } from "../endpoints";

export const getAllNewsletters = async (data) => {
  try {
    const res = await authAxios.post(ApiKey.getNewsletter, data);

    return { error: false, data: res.data };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong. Please try again later.";
    return { error: true, message: error };
  }
};

export const insertNewsletters = async (data) => {
  try {
    const res = await authAxios.post(ApiKey.insertNewsletter, data);
    console.log(res.data.result);

    return { error: false, data: res.data };
  } catch (err) {
    let error;
    if (err.response) error = "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong. Please try again later.";
    return { error: true, message: error };
  }
};

export const deleteNewsletter = async (id) => {
  try {
    const res = await authAxios.post(ApiKey.deleteNewsletter, {
      newsletterId : id
    });
    console.log(res.data);
    
    return { error: false, data: res.data };
  } catch (err) {
    let error;
    if (err.response) error = "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong. Please try again later.";
    console.log("Error during API service");
    return { error: true, message: error };
  }
};


export const toggleNewsletterStatus = async (id) =>{
  try {
    var res = await authAxios.post(ApiKey.toggleNewsletterStatus, {
      newsletterId: id,
    });
     if(res.data.result_value){
      return{error : false , data: res.data}
     }else{
      return { error: true, message: res.data.error_value.errorText };
     }
  } catch (err) {
      let error;
      error = "Something went wrong. Please try again later.";
      console.log("Error during API service");
      return { error: true, message: error };
  }

}


export const GetSngleNewsletter = async (id) =>{
  try {
    var res = await authAxios.post(ApiKey.getSingleNewsletterAdmin, {
      newsletterId: id,
    });
     if(res.data.result_value){
      return{error : false , data: res.data}
     }else{
      return { error: true, message: res.data.error_value.errorText };
     }
  } catch (err) {
      let error;
      error = "Something went wrong. Please try again later.";
      console.log("Error during API service");
      return { error: true, message: error };
  }

}




export const UpdateNewsletter = async (finaldata) =>{
  try {
    var res = await authAxios.post(ApiKey.updateNewsletter, finaldata);
     if(res.data.result_value){
      return{error : false , data: res.data}
     }else{
      return { error: true, message: res.data.error_value.errorText };
     }
  } catch (err) {
      let error;
      error = "Something went wrong. Please try again later.";
      console.log("Error during API service");
      return { error: true, message: error };
  }

}

export const sendNewsLettertoRegisteredEmail = async (id) => {
  try {
    const res = await authAxios.post(ApiKey.newsLetterToRegisteredEmail, {
      newsletterId : id
    });
    console.log(res.data);
    
    return { error: false, data: res.data };
  } catch (err) {
    let error;
    if (err.response) error = "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong. Please try again later.";
    console.log("Error during API service");
    return { error: true, message: error };
  }
};